export const LEFT_PANEL_WIDTH = 200;
export const CANVAS_WIDTH_MIN = 330;
export const RIGHT_SIDEBAR_WIDTH_MIN = 170;
export const WINDOW_WIDTH_MIN = LEFT_PANEL_WIDTH + CANVAS_WIDTH_MIN + RIGHT_SIDEBAR_WIDTH_MIN;
